/* ===========================================================================
   LUPA DA GALERIA DE PRODUTO — 08/09/2026

   Pedido do Elber: ver a foto em tamanho real, "justamente pra conseguir ler
   pois depois irei inserir imagens com textos".

   A finalidade muda o desenho. Isto NAO e um visualizador de fotos bonito: e
   um instrumento de leitura. Por isso:

     - dois estados, e nao uma escala continua. AJUSTE (a foto inteira cabe na
       tela) e REAL (1:1 com o arquivo, que e onde o texto fica legivel). Um
       controle com dez degraus obriga a pessoa a PROCURAR o degrau em que da
       para ler; dois estados entregam o degrau certo no primeiro toque
     - a roda do mouse e a pinca continuam livres, porque quem ja esta lendo
       quer ajustar fino
     - abre sempre em AJUSTE. Abrir ampliado joga a pessoa num pedaco da foto
       sem contexto, e ela perde o que estava olhando

   Arquivo proprio, e nao mais um bloco no site.js: so e carregado nas paginas
   de produto (ver layout/theme.liquid). A home nao paga por isto.

   Sem dependencia externa, no mesmo dialeto ES5 do site.js.
   =========================================================================== */

(function () {
  'use strict';

  var galeria = document.querySelector('[data-galeria]');
  if (!galeria) return;

  var botoes = galeria.querySelectorAll('[data-galeria-zoom]');
  if (!botoes.length) return;

  /* As fotos sao lidas UMA VEZ, na carga. A galeria e estatica depois que a
     pagina monta, e reconsultar o DOM a cada abertura so daria chance de
     divergir do que a pessoa ve. */
  var fotos = [];
  Array.prototype.forEach.call(botoes, function (b) {
    /* Um item por BOTAO, sempre, mesmo que a figura venha sem <img>. Pular o
       item aqui desalinharia o indice do botao com o da foto, e o clique na
       terceira miniatura abriria a quarta imagem. */
    var img = b.parentNode.querySelector('img');
    fotos.push({
      src: img ? (img.getAttribute('data-zoom') || img.currentSrc || img.src) : '',
      alt: img ? (img.getAttribute('alt') || '') : ''
    });
  });

  var cena = null;
  var elFoto, elPalco, elLegenda, elEscala;
  var indice = 0;
  var escala = 1;
  var ajuste = 1;
  var x = 0;
  var y = 0;
  var nw = 0;
  var nh = 0;
  var origem = null;

  var REAL = 1;
  var MAX = 4;

  /* ---------- montagem, sob demanda ---------- */

  function svg(interior) {
    return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" ' +
      'stroke="currentColor" stroke-width="2" stroke-linecap="round" ' +
      'stroke-linejoin="round" aria-hidden="true">' + interior + '</svg>';
  }

  function montar() {
    var el = document.createElement('div');
    el.className = 'zoom';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Foto ampliada');
    el.hidden = true;

    var passos = '';
    if (fotos.length > 1) {
      passos =
        '<button type="button" class="zoom__botao zoom__passo zoom__passo--antes" data-passo="-1" aria-label="Foto anterior">' +
          svg('<path d="M15 5l-7 7 7 7"></path>') +
        '</button>' +
        '<button type="button" class="zoom__botao zoom__passo zoom__passo--depois" data-passo="1" aria-label="Próxima foto">' +
          svg('<path d="M9 5l7 7-7 7"></path>') +
        '</button>';
    }

    el.innerHTML =
      '<div class="zoom__veu" data-fechar></div>' +
      '<div class="zoom__palco" data-palco>' +
        '<img class="zoom__foto" alt="" draggable="false">' +
      '</div>' +
      passos +
      '<div class="zoom__barra">' +
        '<span class="zoom__legenda" data-legenda></span>' +
        '<button type="button" class="zoom__botao" data-escala aria-label="Ver em tamanho real">' +
          svg('<circle cx="10.5" cy="10.5" r="6.5"></circle><path d="M15.5 15.5 21 21"></path><path d="M10.5 7.5v6M7.5 10.5h6"></path>') +
        '</button>' +
        '<button type="button" class="zoom__botao" data-fechar aria-label="Fechar a foto ampliada">' +
          svg('<path d="M6 6l12 12M18 6L6 18"></path>') +
        '</button>' +
      '</div>';

    document.body.appendChild(el);

    elPalco = el.querySelector('[data-palco]');
    elFoto = el.querySelector('.zoom__foto');
    elLegenda = el.querySelector('[data-legenda]');
    elEscala = el.querySelector('[data-escala]');

    el.addEventListener('click', function (e) {
      var fechar = e.target.closest ? e.target.closest('[data-fechar]') : null;
      if (fechar) { fechar_(); return; }
      var passo = e.target.closest ? e.target.closest('[data-passo]') : null;
      if (passo) { ir(indice + Number(passo.getAttribute('data-passo'))); }
    });

    elEscala.addEventListener('click', function () {
      alternar(elPalco.clientWidth / 2, elPalco.clientHeight / 2);
    });

    elFoto.addEventListener('load', aoCarregar);
    ligarGestos();

    return el;
  }

  /* ---------- geometria ----------
     A foto e posicionada com transform e transform-origin no canto superior
     esquerdo. Assim `x` e `y` sao a posicao do canto da imagem no palco, e
     ampliar em torno de um ponto vira uma conta de uma linha em vez de
     compensar o centro a cada nivel. */

  function aplicar() {
    elFoto.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + escala + ')';
    elPalco.classList.toggle('esta-ampliado', escala > ajuste + 0.001);
    if (elEscala) {
      var real = escala >= REAL - 0.001;
      elEscala.setAttribute('aria-label', real ? 'Ver a foto inteira' : 'Ver em tamanho real');
      elEscala.disabled = ajuste >= REAL - 0.001;
    }
  }

  function limitar() {
    var pw = elPalco.clientWidth;
    var ph = elPalco.clientHeight;
    var lw = nw * escala;
    var lh = nh * escala;
    /* Menor que o palco naquele eixo: fica centralizada, e nao encostada.
       Maior: nao deixa sobrar vao entre a borda da foto e a borda da tela. */
    x = lw <= pw ? (pw - lw) / 2 : Math.min(0, Math.max(pw - lw, x));
    y = lh <= ph ? (ph - lh) / 2 : Math.min(0, Math.max(ph - lh, y));
  }

  function calcularAjuste() {
    var pw = elPalco.clientWidth;
    var ph = elPalco.clientHeight;
    if (!nw || !nh || !pw || !ph) return 1;
    /* Teto em 1: no modo AJUSTE a foto nunca e ampliada acima do arquivo.
       Ampliar ali deixaria "ajuste" MAIOR que "tamanho real", e os dois
       botoes passariam a mentir sobre o que fazem. */
    return Math.min(pw / nw, ph / nh, 1);
  }

  function paraEscala(nova, px, py) {
    nova = Math.max(ajuste, Math.min(MAX, nova));
    if (nova === escala) return;
    /* O ponto sob o dedo (ou sob o cursor) continua sob o dedo. */
    x = px - (px - x) * (nova / escala);
    y = py - (py - y) * (nova / escala);
    escala = nova;
    limitar();
    aplicar();
  }

  function alternar(px, py) {
    paraEscala(escala >= REAL - 0.001 ? ajuste : REAL, px, py);
  }

  function aoCarregar() {
    nw = elFoto.naturalWidth;
    nh = elFoto.naturalHeight;
    elFoto.style.width = nw + 'px';
    elFoto.style.height = nh + 'px';
    ajuste = calcularAjuste();
    escala = ajuste;
    limitar();
    aplicar();
  }

  /* ---------- navegacao ---------- */

  function ir(i) {
    if (fotos.length < 2) return;
    indice = (i + fotos.length) % fotos.length;
    carregar();
  }

  function carregar() {
    var f = fotos[indice];
    nw = 0;
    nh = 0;
    elFoto.removeAttribute('src');
    elFoto.setAttribute('alt', f.alt);
    elFoto.src = f.src;
    if (elFoto.complete && elFoto.naturalWidth) aoCarregar();
    elLegenda.textContent = fotos.length > 1
      ? 'Foto ' + (indice + 1) + ' de ' + fotos.length
      : '';
  }

  /* ---------- gestos ----------
     Pointer Events cobre dedo, mouse e caneta com um caminho so. Duas listas
     de eventos (touch + mouse) foi o que fez a versao anterior deste tipo de
     tela disparar o clique duas vezes em aparelho hibrido. */

  function ligarGestos() {
    var ativos = {};
    var arrastou = false;
    var ultimo = null;
    var pinca = null;

    function pontos() {
      var lista = [];
      for (var k in ativos) if (ativos.hasOwnProperty(k)) lista.push(ativos[k]);
      return lista;
    }

    elPalco.addEventListener('pointerdown', function (e) {
      ativos[e.pointerId] = { x: e.clientX, y: e.clientY };
      arrastou = false;
      var p = pontos();
      if (p.length === 1) {
        ultimo = { x: e.clientX, y: e.clientY };
        if (elPalco.setPointerCapture) elPalco.setPointerCapture(e.pointerId);
      } else if (p.length === 2) {
        pinca = { d: dist(p[0], p[1]), e: escala };
        ultimo = null;
      }
    });

    elPalco.addEventListener('pointermove', function (e) {
      if (!ativos[e.pointerId]) return;
      ativos[e.pointerId] = { x: e.clientX, y: e.clientY };
      var p = pontos();
      var r = elPalco.getBoundingClientRect();

      if (p.length >= 2 && pinca) {
        var d = dist(p[0], p[1]);
        if (!pinca.d) return;
        var cx = (p[0].x + p[1].x) / 2 - r.left;
        var cy = (p[0].y + p[1].y) / 2 - r.top;
        arrastou = true;
        elPalco.classList.add('esta-arrastando');
        paraEscala(pinca.e * (d / pinca.d), cx, cy);
        return;
      }

      if (p.length === 1 && ultimo) {
        var dx = e.clientX - ultimo.x;
        var dy = e.clientY - ultimo.y;
        if (Math.abs(dx) + Math.abs(dy) > 3) arrastou = true;
        if (!arrastou) return;
        ultimo = { x: e.clientX, y: e.clientY };
        elPalco.classList.add('esta-arrastando');
        x += dx;
        y += dy;
        limitar();
        aplicar();
      }
    });

    function soltar(e) {
      delete ativos[e.pointerId];
      var p = pontos();
      if (p.length < 2) pinca = null;
      if (!p.length) {
        elPalco.classList.remove('esta-arrastando');
        ultimo = null;
        /* Um toque que nao virou arrasto e um clique: alterna entre ver a
           foto inteira e ler no tamanho real, no ponto que foi tocado. */
        if (!arrastou) {
          var r = elPalco.getBoundingClientRect();
          var px = e.clientX - r.left;
          var py = e.clientY - r.top;
          /* O palco cobre a tela inteira e fica ACIMA do veu, entao o clique
             no escuro nunca chegaria ao veu por conta propria. Sem isto,
             tocar fora da foto ampliava em vez de fechar, que e o contrario
             do que todo visualizador de foto faz. */
          var fora = px < x || py < y || px > x + nw * escala || py > y + nh * escala;
          if (fora) fechar_(); else alternar(px, py);
        }
      }
    }

    elPalco.addEventListener('pointerup', soltar);
    elPalco.addEventListener('pointercancel', soltar);

    elPalco.addEventListener('wheel', function (e) {
      e.preventDefault();
      var r = elPalco.getBoundingClientRect();
      paraEscala(escala * (e.deltaY < 0 ? 1.16 : 1 / 1.16), e.clientX - r.left, e.clientY - r.top);
    }, { passive: false });
  }

  function dist(a, b) {
    var dx = a.x - b.x;
    var dy = a.y - b.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  /* ---------- abrir e fechar ---------- */

  function abrir(i, quem) {
    if (!cena) cena = montar();
    origem = quem || null;
    indice = i;
    cena.hidden = false;
    document.documentElement.classList.add('zoom-travado');
    carregar();

    /* Um respiro entre mostrar e animar, senao o navegador junta os dois
       estados no mesmo calculo de estilo e a transicao nao acontece.

       Este respiro e uma LEITURA de offsetWidth, e nao um requestAnimationFrame.
       Com rAF isto quebrou feio no teste de 08/09: em aba que o navegador nao
       esta pintando, o quadro nunca chega, a classe nunca entra, e o
       visualizador fica com `opacity: 0` e `display: grid` por cima da pagina
       inteira, com a rolagem travada. Ou seja: pagina congelada embaixo de uma
       camada invisivel, que e exatamente o defeito ja documentado duas vezes
       no base.css.

       Ler offsetWidth forca o reflow na hora, de forma sincrona. Nao depende
       de quadro nenhum, entao nao tem como nao acontecer. */
    void cena.offsetWidth;
    cena.classList.add('esta-aberto');
    var fechar = cena.querySelector('.zoom__barra [data-fechar]');
    if (fechar) fechar.focus();
  }

  function fechar_() {
    if (!cena) return;
    cena.classList.remove('esta-aberto');
    document.documentElement.classList.remove('zoom-travado');
    /* Espera a transicao do veu antes de sumir de vez, senao a foto pisca. */
    window.setTimeout(function () {
      cena.hidden = true;
      elFoto.removeAttribute('src');
    }, 200);
    if (origem) { origem.focus(); origem = null; }
  }

  document.addEventListener('keydown', function (e) {
    if (!cena || cena.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); fechar_(); return; }
    if (e.key === 'ArrowRight') { e.preventDefault(); ir(indice + 1); return; }
    if (e.key === 'ArrowLeft') { e.preventDefault(); ir(indice - 1); return; }
    if (e.key === '+' || e.key === '=') { e.preventDefault(); paraEscala(escala * 1.25, elPalco.clientWidth / 2, elPalco.clientHeight / 2); return; }
    if (e.key === '-') { e.preventDefault(); paraEscala(escala / 1.25, elPalco.clientWidth / 2, elPalco.clientHeight / 2); }
  });

  window.addEventListener('resize', function () {
    if (!cena || cena.hidden || !nw) return;
    var antes = ajuste;
    ajuste = calcularAjuste();
    /* Quem estava vendo a foto inteira continua vendo a foto inteira quando
       o aparelho gira. Quem estava lendo ampliado nao perde o lugar. */
    if (escala <= antes + 0.001) escala = ajuste;
    limitar();
    aplicar();
  });

  Array.prototype.forEach.call(botoes, function (b, i) {
    b.addEventListener('click', function () { abrir(i, b); });
  });
})();
